var map = {
	"./number-1.svg": 694,
	"./number-2.svg": 695,
	"./number-3.svg": 696,
	"./number-4.svg": 697,
	"./number-5.svg": 698,
	"./number-6.svg": 699,
	"./number-7.svg": 700,
	"./number-8.svg": 701,
	"./number-9.svg": 702,
	"./number-shine-1.svg": 703,
	"./number-shine-2.svg": 704,
	"./number-shine-3.svg": 705,
	"./number-shine-4.svg": 706,
	"./number-shine-5.svg": 707,
	"./number-shine-6.svg": 708,
	"./number-shine-7.svg": 709,
	"./number-shine-8.svg": 710,
	"./number-shine-9.svg": 711
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 693;